import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=916fd4ba&scoped=true"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"
import style0 from "./StartScreen.vue?vue&type=style&index=0&id=916fd4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916fd4ba",
  null
  
)

export default component.exports